// Plan limits
export const PLAN_LIMITS = {
    free: {
        maxSites: 2,
        maxPipelines: 3,
        maxBrainTasksPerMonth: 10,
        maxMembers: 1,
    },
    starter: {
        maxSites: 10,
        maxPipelines: 10,
        maxBrainTasksPerMonth: 50,
        maxMembers: 3,
    },
    pro: {
        maxSites: 50,
        maxPipelines: 50,
        maxBrainTasksPerMonth: 200,
        maxMembers: 10,
    },
    enterprise: {
        maxSites: -1, // unlimited
        maxPipelines: -1,
        maxBrainTasksPerMonth: -1,
        maxMembers: -1,
    },
};
// Agent types
export const AGENT_TYPES = [
    "deployer",
    "publisher",
    "megan",
    "analyst",
    "creator",
    "optimizer",
    "monitor",
    "scheduler",
    "researcher",
    "arbitrator",
];
// Manus API
export const MANUS_API_BASE = "https://api.manus.ai/v1";
export const MANUS_AGENT_PROFILES = ["manus-1.6", "manus-1.6-lite", "manus-1.6-max"];
// ─── Brain Shortcuts Options ─────────────────────────────────────
export const NICHE_OPTIONS = [
    { value: "credit-cards", label: "Cartão de Crédito / Credit Cards" },
    { value: "auto-insurance", label: "Seguro Auto / Auto Insurance" },
    { value: "home-insurance", label: "Seguro Residencial / Home Insurance" },
    { value: "life-insurance", label: "Seguro de Vida / Life Insurance" },
    { value: "health-insurance", label: "Plano de Saúde / Health Insurance" },
    { value: "personal-loans", label: "Empréstimo Pessoal / Personal Loans" },
    { value: "debt-consolidation", label: "Consolidação de Dívida / Debt Consolidation" },
    { value: "home-warranty", label: "Garantia Residencial / Home Warranty" },
    { value: "solar-energy", label: "Energia Solar / Solar Energy" },
    { value: "pet-insurance", label: "Seguro Pet / Pet Insurance" },
    { value: "jobs", label: "Empregos / Jobs" },
    { value: "education", label: "Educação / Education" },
    { value: "vpn", label: "VPN / Segurança Digital" },
    { value: "dating", label: "Relacionamentos / Dating" },
    { value: "weight-loss", label: "Emagrecimento / Weight Loss" },
    { value: "custom", label: "Personalizado / Custom" },
];
export const GEO_OPTIONS = [
    { value: "US", label: "Estados Unidos" },
    { value: "MX", label: "México" },
    { value: "BR", label: "Brasil" },
    { value: "CO", label: "Colômbia" },
    { value: "ZA", label: "África do Sul" },
    { value: "AR", label: "Argentina" },
    { value: "CL", label: "Chile" },
    { value: "PE", label: "Peru" },
    { value: "IN", label: "Índia" },
    { value: "PH", label: "Filipinas" },
    { value: "NG", label: "Nigéria" },
    { value: "KE", label: "Quênia" },
];
export const DOMAIN_OPTIONS = [
    { value: "ymonetize.com", label: "ymonetize.com" },
    { value: "mixcredito.com", label: "mixcredito.com" },
    { value: "easycreditfinder.com", label: "easycreditfinder.com" },
    { value: "99newsjobs.com", label: "99newsjobs.com" },
];
export const PROJECT_OPTIONS = [
    { value: "ytrader", label: "YTrader" },
    { value: "mixcredito", label: "MixCredito" },
    { value: "finanza", label: "FinanZA" },
    { value: "cardwise", label: "CardWise Pro" },
    { value: "drivesure", label: "DriveSure Quotes" },
];
export const GEO_LANGUAGE_MAP = {
    MX: "es", BR: "pt-BR", US: "en", CO: "es", ZA: "en",
    AR: "es", CL: "es", PE: "es", EC: "es", IN: "en",
    PH: "en", NG: "en", KE: "en",
};
export const GEO_CURRENCY_MAP = {
    MX: "MXN", BR: "BRL", US: "USD", CO: "COP", ZA: "ZAR",
    AR: "ARS", CL: "CLP", PE: "PEN", IN: "INR", PH: "PHP",
    NG: "NGN", KE: "KES",
};
// Token expiry
export const ACCESS_TOKEN_EXPIRY = "15m";
export const REFRESH_TOKEN_EXPIRY = "7d";
export const ACCESS_TOKEN_EXPIRY_MS = 15 * 60 * 1000;
export const REFRESH_TOKEN_EXPIRY_MS = 7 * 24 * 60 * 60 * 1000;
//# sourceMappingURL=index.js.map